import { Routes } from "@/router/routes";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SESSION_TIMEOUT = 60 * 60 * 1000;
const WARNING_TIME = 5 * 60 * 1000;

export const useSessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const loginTime = Number(localStorage.getItem("loginTime")) || Date.now();
    const timeRemaining = SESSION_TIMEOUT - (Date.now() - loginTime);

    if (timeRemaining <= 0) {
      alert("セッションは期限切れです。 もう一度ログインしてください。");
      navigate(Routes.LOGIN);
      return;
    }

    // 満了5分前の警告
    const warningTimer = setTimeout(() => {
      alert(
        "セッションは5分後に期限切れになります。 継続して使用するには、再度ログインしてください"
      );
    }, timeRemaining - WARNING_TIME);

    // セッション満了タイマー
    const logoutTimer = setTimeout(() => {
      alert("セッションは期限切れです。 もう一度ログインしてください。");
      navigate(Routes.LOGIN);
    }, timeRemaining);

    // ユーザーの活動を感知してセッションを自動延長
    const resetSession = () => {
      localStorage.setItem("loginTime", Date.now().toString());
    };

    window.addEventListener("mousemove", resetSession);
    window.addEventListener("keydown", resetSession);

    return () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", resetSession);
      window.removeEventListener("keydown", resetSession);
    };
  }, [navigate]);
};
